export const swedishCountryIso2 = "se";
export const britishCountryIso2 = "gb";

export const getCurrentCountryIso = () => window.config.countryIso2.toLowerCase();
